import brand from '@helpers/brand';
import fonts from '@helpers/fonts';
import global from '@helpers/global';
import { Device, from, until } from '@helpers/media';
import { headerOverlap } from '@helpers/utils';
import SiteWide from '@stories/Components/Global/SiteWide/SiteWide';
import SectionWrapper from '@stories/Components/SectionWrapper/SectionWrapper';
import { m } from 'framer-motion';
import { rgba } from 'polished';
import styled, { css } from 'styled-components';
import RichTextStyles from '../RichText/RichText.styles';
const Container = styled(SectionWrapper) `
  position: relative;
  display: grid;
  height: auto;
  min-height: 391px;
  ${headerOverlap}

  @media ${from(Device.Tablet)} {
    height: 675px;
    max-height: none;
    min-height: 0;
  }

  &[data-height='viewport'] {
    height: auto;
    min-height: 100vh;
    max-height: none;
    overflow: hidden;
  }
`;
const Inner = styled(m.div) ``;
const ImageWrapper = styled.div `
  position: absolute;
  top: 0;
  left: 0;
  height: 100%;
  object-fit: cover;
  object-position: center center;
  overflow: hidden;
  width: 100%;
  z-index: 1;
`;
const Image = styled(m.img) `
  display: block;
  height: 100%;
  object-fit: cover;
  object-position: center center;
  width: 100%;
`;
const Overlay = styled(m.div) `
  position: absolute;
  top: 0;
  left: 0;
  background: ${rgba(brand.black, 0.85)};
  height: 100%;
  width: 100%;
  z-index: 2;

  ${({ gradientOverlayPercentage }) => gradientOverlayPercentage !== undefined &&
    css `
      background: linear-gradient(
        20deg,
        ${rgba(brand.black, 0.85)} 0%,
        ${rgba(brand.black, 0)} calc(${gradientOverlayPercentage}% * 5)
      );
    `}
`;
const ContentWrapper = styled(SiteWide) `
  position: relative;
  display: flex;
  align-items: flex-start;
  flex-direction: column;
  height: 100%;
  justify-content: center;
  z-index: 3;
`;
const ContentWrapperInner = styled.div `
  @media ${until(Device.Tablet)} {
    padding: ${global.navHeightTablet}px 0;
  }
`;
const Subtitle = styled(m.h2) `
  display: block;
  color: ${brand.gold};
  ${fonts.workSans.medium};
  font-size: 14px;
  line-height: 16px;
  letter-spacing: 0.146em;
  margin: 0;
  max-width: 804px;
  text-transform: uppercase;

  @media ${from(Device.Tablet)} {
    font-size: 14px;
    line-height: 16px;
  }

  @media ${from(Device.Desktop)} {
    font-size: 20px;
    line-height: 24px;
    margin: 0 0 8px;
    padding: 0 0 10px;
  }

  @media ${from(Device.DesktopLarge)} {
    font-size: 23px;
    line-height: 27px;
  }
`;
const Title = styled(m.h1) `
  position: relative;
  display: block;
  color: ${brand.white};
  ${fonts.crimsonText.regular};
  font-size: 35px;
  line-height: 45px;
  margin: 0 0 12px;
  max-width: 804px;

  @media ${from(Device.Tablet)} {
    font-size: 60px;
    line-height: 70px;
  }

  @media ${from(Device.TabletLarge)} {
    font-size: 70px;
    line-height: 80px;
  }
`;
const Content = styled(m.p) `
  ${RichTextStyles.contentStyles};
  color: ${brand.white};
  ${fonts.workSans.regular};
  font-size: 18px;
  line-height: 28px;
  max-width: 820px;

  @media ${from(Device.TabletLarge)} {
    font-size: 24px;
    line-height: 38px;
  }

  a {
    color: ${brand.gold};

    &:focus,
    &:hover {
      color: ${brand.black};
    }
  }
`;
const Line = styled(m.span) `
  position: absolute;
  bottom: -27px;
  left: var(--sitePadding);
  display: block;
  background: ${brand.gold};
  height: 100px;
  transform-origin: top center;
  width: 2px;

  @media ${from(769)} {
    bottom: -74px;
    height: 233px;
  }
`;
export default {
    Container,
    Content,
    ContentWrapper,
    ContentWrapperInner,
    Image,
    ImageWrapper,
    Inner,
    Line,
    Overlay,
    Subtitle,
    Title,
};
